// client/plugins/ObsidianLinkPlugin/ObsidianLinkPlugin.ts
import { XNativeDialog } from "@adornis/dialog/x-native-dialog.js";
import { Plugin, PluginKey, TextSelection } from "prosemirror-state";
import { GlobalLinkHelper } from "./helper/index.js";
var obsidianLinkPlugin = (searchFn) => {
  let component;
  const removeComponent = () => {
    if (component) {
      component.remove();
      component = null;
    }
    return false;
  };
  const insertComponent = (coords, view, search) => {
    if (component)
      return;
    component = document.createElement("x-obsidian-link-selection");
    component.editorView = view;
    component.searchFn = searchFn;
    component.addEventListener("close", () => {
      removeComponent();
    });
    const attachTarget = view.dom ? _lookForDialogElementInParents(view.dom) : document.body;
    const attachTargetBoundingClientRect = attachTarget instanceof XNativeDialog ? attachTarget.renderRoot.querySelector("dialog")?.getBoundingClientRect() ?? attachTarget.getBoundingClientRect() : attachTarget.getBoundingClientRect();
    const OFFSET = 20;
    const left = coords.left + OFFSET - attachTargetBoundingClientRect.x;
    const top = coords.top + OFFSET - attachTargetBoundingClientRect.y;
    component.style.left = `${left}px`;
    component.style.top = `${top}px`;
    attachTarget.appendChild(component);
  };
  const updateSearch = (view) => {
    const input = GlobalLinkHelper.HandleInput.search(view, "");
    if (input === void 0)
      return removeComponent();
    const searchParts = input.split("|");
    if (searchParts.length > 2)
      throw new Error(`you shouldn't be able to use more than one pipe o.O`);
    const search = searchParts[0];
    if (!search && typeof search !== "string")
      throw new Error("search not given");
    if (!component)
      insertComponent(view.coordsAtPos(view.state.selection.$from.pos), view);
    if (!component)
      throw new Error("how can this be?");
    component.search = search;
  };
  return new Plugin({
    key: new PluginKey("obsidianLinkPlugin"),
    state: {
      init() {
        return null;
      },
      apply(tr, value) {
        return value;
      }
    },
    view(editorView) {
      const handleCursorMovement = () => {
        const parsedText = GlobalLinkHelper.ParseNode.TextToLink({ view: editorView });
        if (!parsedText)
          GlobalLinkHelper.ParseNode.LinkToText({ view: editorView });
      };
      editorView.dom.addEventListener("click", handleCursorMovement);
      editorView.dom.addEventListener("keyup", handleCursorMovement);
      return {
        update(view) {
          updateSearch(view);
        },
        destroy() {
          editorView.dom.removeEventListener("click", handleCursorMovement);
          editorView.dom.removeEventListener("keyup", handleCursorMovement);
        }
      };
    },
    props: {
      handleTextInput(view, from, to, text) {
        if (text === "[" && view.state.doc.textBetween(from - 1, from) === "[") {
          const { tr } = view.state;
          tr.insertText("[]]", from, from);
          tr.setSelection(TextSelection.create(tr.doc, from + 1));
          view.dispatch(tr);
          const coords = view.coordsAtPos(from + 1);
          insertComponent(coords, view, "");
          return true;
        }
        if (text === "|" && GlobalLinkHelper.HandleInput.isInputAlreadyPiped(view))
          return true;
        return false;
      },
      handleKeyDown(view, event) {
        const component2 = document.querySelector("x-obsidian-link-selection");
        if (event.key === "ArrowUp" && component2) {
          component2.onArrowUp();
          return true;
        }
        if (event.key === "ArrowDown" && component2) {
          component2.onArrowDown();
          return true;
        }
        if (event.key === "Enter" && component2) {
          component2.onItemSelect();
          return true;
        }
        if (event.key === "Escape" && component2) {
          component2.remove();
          return true;
        }
        if (event.ctrlKey && event.code === "Space") {
          const input = GlobalLinkHelper.HandleInput.search(view, "");
          if (input) {
            const coords = view.coordsAtPos(view.state.selection.from);
            insertComponent(coords, view, input);
            return true;
          }
        }
        return false;
      }
    }
  });
};
function _lookForDialogElementInParents(start) {
  let curr = start;
  while (
    // @ts-expect-error host exists on rootNode in this context
    (curr = curr.parentElement || curr.getRootNode()?.host) && !(curr instanceof HTMLDialogElement) && !(curr instanceof XNativeDialog)
  ) {
  }
  if (curr instanceof HTMLDialogElement || curr instanceof XNativeDialog)
    return curr;
  return window.document.body;
}
export {
  obsidianLinkPlugin
};
